import { estadosSolicitud } from "@/lib/solicitudEstados";

interface EstadoDistributionProps {
  counts: Record<string, number>;
  total: number;
}

export default function EstadoDistribution({ counts, total }: EstadoDistributionProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-heading font-semibold text-foreground-950">
          Solicitudes por estado
        </h2>
        <span className="text-xs font-label text-foreground-500">{total} en total</span>
      </div>

      {total === 0 ? (
        <p className="mt-6 text-sm text-foreground-500">
          Todavía no hay solicitudes registradas. Cuando lleguen, verás aquí su distribución.
        </p>
      ) : (
        <ul className="mt-5 space-y-4">
          {estadosSolicitud.map((estado) => {
            const value = counts[estado.value] ?? 0;
            const pct = total > 0 ? Math.round((value / total) * 100) : 0;
            return (
              <li key={estado.value}>
                <div className="mb-1.5 flex items-center justify-between text-sm">
                  <span className="flex items-center gap-2 text-foreground-700">
                    <span className={`h-2 w-2 rounded-full ${estado.dot}`} aria-hidden="true"></span>
                    {estado.label}
                  </span>
                  <span className="font-label font-semibold text-foreground-900">
                    {value} <span className="text-xs font-normal text-foreground-400">· {pct}%</span>
                  </span>
                </div>
                <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className={`h-full rounded-full ${estado.dot} transition-all duration-500`}
                    style={{ width: `${pct}%` }}
                  ></div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}